import MasterTab from 'src/components/Layouts/MasterTab.vue';
import FinishedProductQuality from "src/views/Pages/Dashboard/Grow/Reports/FinishedProductQuality/FinishedProductQuality.vue";
import EmptyRouterView from 'src/views/Pages/GeneralViews/EmptyRouterView.vue';

const FinishedProductQualityRoutes = {
  path: 'grow',
  name: 'grow.grow',
  component: MasterTab,
  props: { reference: 'growTabs' },
  children: [
    {
      path: 'finishedproduct',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'grow.finished_product_quality',
          component: FinishedProductQuality,
          meta: {
            prefix_permission: 'grow_finishedproduct',
          },
        },
      ],
    },
  ],
};

export default FinishedProductQualityRoutes;